import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { Ocupacion } from '../../models/ocupacion/ocupacion';

@Injectable({
  providedIn: 'root',
})
export class OcupacionesService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.OCUPACIONES}`;
  constructor(private http: HttpClient) {}

  getOcupaciones(): Observable<Ocupacion[]> {
    return this.http.get<Ocupacion[]>(this.apiUrl);
  }
}
